import { useContext } from 'react';

import AuthGuardContext from './AuthGuardContext.js';

export const useAuthGuardContext = (throws: boolean = false) => {
  const ctx = useContext(AuthGuardContext);

  if (throws && !ctx) {
    throw new Error('AuthGuardContext is should be used inside AuthGuardProvider');
  }

  return ctx;
};

export default useAuthGuardContext;